import React from 'react'
import { convertToJson, getExention } from '../../utils/fileUtil'
import { Button } from '@deere/ux.uxframe-react'
import UploadFileIcon from '@mui/icons-material/UploadFile';
import * as XLSX from 'xlsx'

export const InputFile = ({ setData, setColDefs, loading }) => {
    const hiddenFileInput = React.useRef(null);

    const handleFileChange = event => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        const file = fileObj;
        const reader = new FileReader()
        reader.onload = (event) => {
            const bstr = event.target.result
            const workBook = XLSX.read(bstr, { type: "binary" })
            const workSheetName = workBook.SheetNames[0]
            const workSheet = workBook.Sheets[workSheetName]
            const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1, blankrows: false })
            const headers = fileData[0]
            const heads = headers.map(head => ({ headerName: head, field: head, minWidth: 150, flex: 1 }))
            setColDefs(heads)
            setData(convertToJson(headers, fileData))
            event.target.value = ''
        }
        if (file) {
            if (getExention(file)) {
                reader.readAsBinaryString(file)
            }
            else {
                alert("Invalid file input, Select Excel, CSV file")
            }
        } else {
            setData([])
        }
    }

    const handleClick = (event) => {
        hiddenFileInput.current.value = "";
        hiddenFileInput.current.click();
    }

    return (
        <div>
            <input
                style={{ display: 'none' }}
                type="file"
                onChange={handleFileChange}
                ref={hiddenFileInput}
            />
            <Button variant="secondary" startIcon={<UploadFileIcon />} onClick={handleClick} disabled={loading}>
                Import File
            </Button>
        </div>
    )
}